var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('video',{ref:"vid",attrs:{"id":"player","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }